export const smsSnippetAdapter = (snippet) => ({
  id: snippet.id,
  name: snippet.name,
  title: snippet.title,
  phrase: snippet.phrase,
});
